import React, { useEffect } from "react";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";
import { useForm } from "react-hook-form";
import CustomDescriptionInput from "../../../../components/UI/PageInput/CustomDescriptionInput";
import Modal from "../../../../components/portal/Modal";

const VisitCheckConfirm = ({
  title,
  cancelOnclick,
  checkAction,
  setBodyData,
  checkLoading,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    watch((value) => {
      setBodyData((prev) => ({ ...prev, ...value }));
    });
  }, [watch]);

  const onSubmit = () => {
    checkAction();
  };
  return (
    <Modal
      onClose={checkLoading ? undefined : cancelOnclick}
      modalWidth="visit-check-confirm"
    >
      <div className="px-10">
        <h1 className="visit-check-confirm-title">{title}</h1>
        <form>
          <CustomDescriptionInput
            name="remark"
            labelText="Remark *"
            register={{
              ...register("remark", {
                required: "Please Enter Description",
              }),
            }}
            error={errors.remark}
          />
        </form>
        <div className="gap-2 flex-center-align">
          <GradientButton
            btnText={!checkLoading ? "Confirm" : "Loading..."}
            onClick={!checkLoading ? handleSubmit(onSubmit) : undefined}
          />
          <GrayButton btnText="Cancel" onClick={cancelOnclick} />
        </div>
      </div>
    </Modal>
  );
};

export default VisitCheckConfirm;
